/* eslint-disable class-methods-use-this, prefer-destructuring, no-undef, no-shadow, no-unused-vars */
import FsLightbox from "fslightbox"; // eslint-disable-line

class Cta {
	constructor() {
		this.videoPlayButton = document.getElementsByClassName("js-video-play")[0];
		if (this.videoPlayButton) {
			this.init();
		}
	}

	init() {
		const videoPlayButtons = document.getElementsByClassName("js-video-play");

		refreshFsLightbox(); // eslint-disable-line

		Array.prototype.forEach.call(videoPlayButtons, (videoPlayButton) => {
			const lightboxDataAttribute = videoPlayButton.dataset.fslightbox;
			
			// Validar que la instancia existe
			if (!fsLightboxInstances || !fsLightboxInstances[lightboxDataAttribute]) {
				console.warn(`FsLightbox instance not found for: ${lightboxDataAttribute}`);
				return;
			}

			// Autoplay popup video
			fsLightboxInstances[lightboxDataAttribute].props.onOpen = (
				FsLightbox
			) => {
				// eslint-disable-line
				let attempts = 0;
				const maxAttempts = 10; // Limitar intentos para evitar bucle infinito

				function playWhenReady() {
					const video = document.querySelector(".fslightbox-container video");
					
					if (video) {
						video.play().catch(console.error);
						return true;
					} else if (attempts < maxAttempts) {
						attempts++;
						setTimeout(playWhenReady, 500);
					} else {
						console.warn('Video element not found after maximum attempts');
					}
					return false;
				}
				return playWhenReady();
			};
		});
	}
}

export default Cta;
